import { render, staticRenderFns } from "./MailLinkLayout.vue?vue&type=template&id=857494dc&"
import script from "./MailLinkLayout.vue?vue&type=script&lang=js&"
export * from "./MailLinkLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports